var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { attrs: { id: "header-banner" } }, [
      _c("img", {
        directives: [
          {
            name: "lazy",
            rawName: "v-lazy",
            value: "https://beneat.co/static/img/bigCleaningNew/HEADER.png",
            expression:
              "'https://beneat.co/static/img/bigCleaningNew/HEADER.png'"
          }
        ],
        staticClass: "header-image d-none d-md-block",
        attrs: {
          alt:
            "บริการทำความสะอาดใหญ่ (Big Cleaning) สำหรับบ้าน คอนโด ออฟฟิศ - BeNeat"
        }
      }),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "lazy",
            rawName: "v-lazy",
            value:
              "https://beneat.co/static/img/bigCleaningNew/HEADER_MOBILE.png",
            expression:
              "'https://beneat.co/static/img/bigCleaningNew/HEADER_MOBILE.png'"
          }
        ],
        staticClass: "header-image d-block d-md-none",
        attrs: {
          alt:
            "บริการทำความสะอาดใหญ่ (Big Cleaning) สำหรับบ้าน คอนโด ออฟฟิศ - BeNeat (Mobile)"
        }
      })
    ]),
    _vm._v(" "),
    _c("section", { attrs: { id: "what-big-cleaning-do" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-md-6 order-2 order-md-1" }, [
            _c(
              "div",
              {
                staticClass: "card",
                attrs: { id: "what-big-cleaning-service" }
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("h2", {
                    staticClass: "text-center",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("message.service_request.what_big_clean_do")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "p-3",
                      staticStyle: { background: "#DBFAFF" }
                    },
                    [
                      _vm._v(
                        "\n                  การทำความสะอาดครั้งใหญ่ ทุกห้องที่อยู่ภายในบ้านทุกซอกทุกมุม\n                  ทุกพื้นผิวของวัสดุภายในบ้าน เช่น พื้น ผนัง เพดาน ระเบียง กระจก\n                  รางกระจก วงกบประตู หน้าต่าง โต๊ะ ตู้ เตียง ที่นอน ชั้นวางของ\n                  และเหมารวมทุกห้องที่อยู่ภายในบ้าน\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: "/static/img/bigCleaningNew/BC_TODO_1.png",
                      alt: "ทำความสะอาดทุกซอกทุกมุม ทุกพื้นผิด"
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: "/static/img/bigCleaningNew/BC_TODO_2.png",
                      alt: "ทำความสะอาดรอบตัวบ้าน ภายในบ้าน ด้วยอุปกรณ์มืออาชีพ"
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6 order-1 order-md-2" }, [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body", attrs: { id: "form-service" } },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.confirmSubmit.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.contactData.name,
                              expression: "contactData.name"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "name", required: "" },
                          domProps: { value: _vm.contactData.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.contactData,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.contactData.email,
                              expression: "contactData.email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "email", id: "email", required: "" },
                          domProps: { value: _vm.contactData.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.contactData,
                                "email",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.contactData.tel,
                              expression: "contactData.tel"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "tel",
                            maxlength: "10",
                            minlength: "10",
                            id: "tel",
                            required: ""
                          },
                          domProps: { value: _vm.contactData.tel },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.contactData,
                                "tel",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _vm._m(8),
                          _vm._v(" "),
                          _vm._l(
                            _vm.globalState.configData.big_cleaning_types,
                            function(data) {
                              return _c(
                                "div",
                                {
                                  key: data.id,
                                  staticClass: "radio-coppy-custom"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.contactData
                                            .service_request_purpose_id,
                                        expression:
                                          "contactData.service_request_purpose_id"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      id: "ebig-cleaning-radio-id-" + data.id,
                                      name: "ebig-cleaning-radio"
                                    },
                                    domProps: {
                                      value: data.id,
                                      checked: _vm._q(
                                        _vm.contactData
                                          .service_request_purpose_id,
                                        data.id
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.contactData,
                                          "service_request_purpose_id",
                                          data.id
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "style-lable py-2 pl-2",
                                      attrs: {
                                        for: "ebig-cleaning-radio-id-" + data.id
                                      }
                                    },
                                    [
                                      _c("span"),
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("multiLangName")(
                                              _vm.nameReplase(data)
                                            )
                                          ) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                ]
                              )
                            }
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _vm._m(9),
                          _vm._v(" "),
                          _c(
                            "v-select",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              ref: "province_address",
                              class: [
                                {
                                  "form-alert": _vm.errors.has(
                                    "province_address"
                                  )
                                },
                                "custom-v-select"
                              ],
                              attrs: {
                                options: _vm.addressProvinces,
                                placeholder: _vm.$t(
                                  "message.service_request.big_cleaning_building_require_province"
                                ),
                                label: "name_th",
                                id: "province_address",
                                name: "province_address",
                                reduce: function(addressProvince) {
                                  return addressProvince.id
                                },
                                selectable: function(option) {
                                  return option.id > 0
                                },
                                disabled: _vm.disableSelectProvince
                              },
                              on: { "option:selected": _vm.clearTyping },
                              scopedSlots: _vm._u([
                                {
                                  key: "option",
                                  fn: function(option) {
                                    return [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(option.name_th) +
                                          "\n                      "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "search",
                                  fn: function(ref) {
                                    var attributes = ref.attributes
                                    var events = ref.events
                                    return [
                                      _c(
                                        "input",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "vs__search",
                                              attrs: {
                                                required: !_vm.contactData
                                                  .address_province_id
                                              }
                                            },
                                            "input",
                                            attributes,
                                            false
                                          ),
                                          events
                                        )
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.contactData.address_province_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contactData,
                                    "address_province_id",
                                    $$v
                                  )
                                },
                                expression: "contactData.address_province_id"
                              }
                            },
                            [
                              _vm._v(" "),
                              _vm._v(" "),
                              _c("template", { slot: "no-options" }, [
                                _vm._v(
                                  "\n                        กรุณาพิมพ์จังหวัดที่ใช้บริการ\n                      "
                                )
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _vm._m(10),
                          _vm._v(" "),
                          _c(
                            "v-select",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              ref: "district_address",
                              class: [
                                {
                                  "form-alert": _vm.errors.has(
                                    "province_address"
                                  )
                                },
                                "custom-v-select"
                              ],
                              attrs: {
                                options: _vm.addressDistricts,
                                placeholder: _vm.$t(
                                  "message.service_request.big_cleaning_building_require_district"
                                ),
                                label: "name_th",
                                id: "district_address",
                                name: "district_address",
                                reduce: function(addressDistrict) {
                                  return addressDistrict.id
                                },
                                selectable: function(option) {
                                  return option.id > 0
                                },
                                disabled:
                                  !_vm.contactData.address_province_id ||
                                  _vm.disableSelectDistrict
                              },
                              on: { "option:selected": _vm.clearTyping },
                              scopedSlots: _vm._u([
                                {
                                  key: "option",
                                  fn: function(option) {
                                    return [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(option.name_th) +
                                          "\n                      "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "search",
                                  fn: function(ref) {
                                    var attributes = ref.attributes
                                    var events = ref.events
                                    return [
                                      _c(
                                        "input",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "vs__search",
                                              attrs: {
                                                required: !_vm.contactData
                                                  .district_id
                                              }
                                            },
                                            "input",
                                            attributes,
                                            false
                                          ),
                                          events
                                        )
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.contactData.district_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.contactData, "district_id", $$v)
                                },
                                expression: "contactData.district_id"
                              }
                            },
                            [
                              _vm._v(" "),
                              _vm._v(" "),
                              _c("template", { slot: "no-options" }, [
                                _vm._v(
                                  "\n                        กรุณาพิมพ์อำเภอที่ใช้บริการ\n                      "
                                )
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "district" } }, [
                            _vm._v("แขวง/ตำบล")
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            ref: "district_address",
                            class: [
                              {
                                "form-alert": _vm.errors.has("province_address")
                              },
                              "custom-v-select"
                            ],
                            attrs: {
                              options: _vm.addressSubDistricts,
                              placeholder: _vm.$t(
                                "message.service_request.big_cleaning_building_require_sub_district"
                              ),
                              label: "name_th",
                              id: "district_address",
                              name: "district_address",
                              reduce: function(addressDubDistrict) {
                                return addressDubDistrict.id
                              },
                              selectable: function(option) {
                                return option.id > 0
                              },
                              disabled:
                                !_vm.contactData.district_id ||
                                _vm.disableSelectSubDistrict
                            },
                            on: { "option:selected": _vm.clearTyping },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(option.name_th) +
                                        "\n                      "
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.contactData.sub_district_id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contactData,
                                  "sub_district_id",
                                  $$v
                                )
                              },
                              expression: "contactData.sub_district_id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row py-3" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _vm._m(11),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-remark mb-2" }, [
                              _c("i", {
                                staticClass:
                                  "fas fa-circle fa-sm -status-pending"
                              }),
                              _vm._v(
                                " \n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.service_request.big_cleaning_attach_photos_remark"
                                    )
                                  ) +
                                  "\n                      "
                              )
                            ]),
                            _vm._v(" "),
                            _c("vue-dropzone", {
                              ref: "vueDropzone",
                              staticClass: "dropzone-dashed",
                              attrs: {
                                id: "dropzone",
                                options: _vm.dropzoneOptions
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(12),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button button-block button-large -cyan",
                            attrs: {
                              type: "submit",
                              disabled: _vm.isSubmitting
                            }
                          },
                          [
                            _vm._v(
                              "\n                      ส่งคำขอประเมินราคา\n                    "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { attrs: { id: "who-cleaning-for" } }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 add-extra-padding" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h2", { staticClass: "text-center" }, [
                  _vm._v(
                    _vm._s(_vm.$t("message.service_request.who_cleaning_for"))
                  )
                ]),
                _vm._v(" "),
                _c("hr", {
                  staticStyle: { "border-top": "2px solid #39C9E2" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _vm._m(13),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-6 d-flex flex-wrap align-content-between"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-justify" }, [
                          _c("span", { staticClass: "text-semi-bold" }, [
                            _vm._v(
                              "บริการทำความสะอาดใหญ่ Big Cleaning ของบีนีท"
                            )
                          ]),
                          _vm._v(
                            "\n                        เหมาะสำหรับที่พักอาศัย\n                        บ้าน คอนโด หรือ สำนักงาน ที่ไม่ได้ทำความสะอาดมานาน ทีมงานมืออาชีพ\n                        ของเราจะเข้าไปทำความสะอาดครบจบทุกขั้นตอน ทุกซอกทุกมุมในบ้าน ให้\n                        ที่พักของคุณลูกค้าทุกท่านสะอาด หมดจด ตั้งแต่บริเวณภายในบ้าน เช่น ห้องนอน\n                        ห้องน้ำ ห้องครัว ต่างๆ ทุกสภาพพื้นผิวและอุปกรณ์ภายในบ้าน ไม่ว่าจะเป็น\n                        พื้น ผนัง เพดาน ระเบียง บันได ขอบวงกบประตู หน้าต่าง เฟอร์นิเจอร์\n                        เครื่องใช้ไฟฟ้า อื่นๆ รวมถึงบริเวณภายนอกที่อยู่อาศัย ลานจอดรถ ลานซักล้าง\n                        เป็นต้น "
                          ),
                          _c("span", { staticClass: "text-semi-bold" }, [
                            _vm._v("บริการทำความสะอาดใหญ่")
                          ]),
                          _vm._v(
                            "\n                        นั้นจะเป็นการทำความสะอาดที่สะอาด\n                        กว่าปกติ ที่ขจัดสิ่งสกปรก คราบฝังลึก และฝุ่นละอองตามซอกต่างๆ ทุกจุดใน\n                        บ้านอีกด้วย\n                        "
                          ),
                          _c(
                            "div",
                            {
                              class: !_vm.$mq.phone
                                ? "d-inline-block"
                                : "d-block d-flex justify-content-center"
                            },
                            [_vm._m(14)]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(15)
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-5" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-6 d-flex flex-wrap align-content-between order-1 order-md-0"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-justify" }, [
                          _c("div", [
                            _vm._v(
                              "\n                          สิ่งที่ควรทำ ก่อน-หลัง ย้ายที่พักอาศัยใหม่ หรือ ที่ทำงาน ก็คือการทำความสะอาดที่พักอาศัย บ้าน\n                          คอนโด และสำนักงาน โดยทีมงาน ทำความสะอาดใหญ่บีนีท\n                          ถึงแม้ว่าการย้ายเข้าที่พักอาศัยใหม่จะสะอาดอยู่แล้ว แต่อาจจะยังสะอาดไม่พอ เนื่องจากฝุ่น\n                          คราบสกปรก และเชื้อโรคต่างๆอาจะยังฝั่งลึกและยังไม่หมดไป\n                          ซึ่งก่อนย้ายเข้าที่พักอาศัยหรือบ้านใหม่นั้น\n                          ความสะอาดและความปลอดภัยของคนในครอบครัวจึงเป็นสิ่งสำคัญ โดยเฉพาะเฟอร์นิเจอร์ต่างๆ ภายในบ้าน\n                          เช่น โซฟา ผ้าม่าน ที่นอน พรม ชั้นวางบิ้วอิน และ ของตกแต่ง\n                          ต่างๆภายในบ้าน ยิ่งต้องดูแลและทำความสะอาดเป็นพิเศษ ดังนั้นการ"
                            ),
                            _c("span", { staticClass: "text-semi-bold" }, [
                              _vm._v(
                                "ทำความสะอาดก่อนเข้าอยู่และหลังย้ายออกจึงเป็นสิ่งสำคัญมาก"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: !_vm.$mq.phone
                                  ? "d-inline-block"
                                  : "d-block d-flex justify-content-center"
                              },
                              [_vm._m(16)]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(17)
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(18)
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-5" }, [
                  _vm._m(19),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-6 d-flex flex-wrap align-content-between"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-justify" }, [
                          _c("span", { staticClass: "text-semi-bold" }, [
                            _vm._v(
                              "บริการทำความสะอาดหลังการก่อสร้างและรีโนเวทที่พักอาศัย"
                            )
                          ]),
                          _vm._v(
                            "\n                        ประสบการณ์\n                        การทำงานของทีมงานบีนีทที่เป็นมืออาชีพ คุณลูกค้าวางใจได้เลยว่าการ"
                          ),
                          _c("span", { staticClass: "text-semi-bold" }, [
                            _vm._v(
                              "ทำความ\n                            สะอาดใหญ่หลังการก่อสร้าง"
                            )
                          ]),
                          _vm._v(
                            " ของบีนีทนั้นจะออกมาดีและสะอาดทุกซอกทุกมุม\n                        ตั้งแต่การเก็บกวาดทำความสะอาดฝุ่นผง เศษวัสดุก่อสร้าง เช่น เศษปูน คอนกรีต\n                        เหล็ก และไม้ที่หลงเหลือจากงานก่อสร้างหรืองานต่อเติม ขัดล้างพื้นที่เปื้อนปูน\n                        คราบกาว สี เก็บกวาดพื้นที่ให้สะอาดหมดจดให้ท่านพร้อมเข้าอยู่หรือเข้าใช้งาน\n                        ได้อย่างปลอดภัย ช่วยทำความสะอาดในจุดที่ยากแก่การทำความสะอาด เช่น\n                        การทำความสะอาดกระจกในที่สูง หรือสามารถเลือกใช้วิธี และผลิตภันฑ์\n                        ทำความสะอาดที่เหมาะสมกับประเภทและชนิดของพื้นผิวได้\n                        "
                          ),
                          _c(
                            "div",
                            {
                              class: !_vm.$mq.phone
                                ? "d-inline-block"
                                : "d-block d-flex justify-content-center"
                            },
                            [_vm._m(20)]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(21)
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { attrs: { id: "customer-review" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h2", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.$t("message.big_cleaning.topic_review")))
                ]),
                _vm._v(" "),
                _vm._m(22),
                _vm._v(" "),
                _vm._m(23)
              ]),
              _vm._v(" "),
              _vm._m(24)
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "section-padding-gray",
        attrs: { id: "frequently-asked-question" }
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-md-8 col-12" }, [
              _c("h2", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("message.big_cleaning.faq_title")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("message.big_cleaning.faq_topic01")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "big-cleaning-faq-description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.big_cleaning.faq_topic01_description")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("message.big_cleaning.faq_topic02")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "big-cleaning-faq-description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.big_cleaning.faq_topic02_description")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("message.big_cleaning.faq_topic03")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "big-cleaning-faq-description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.big_cleaning.faq_topic03_description")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("message.big_cleaning.faq_topic04")))
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "big-cleaning-faq-description",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("message.big_cleaning.faq_topic04_description")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("message.big_cleaning.faq_topic05")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "big-cleaning-faq-description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.big_cleaning.faq_topic05_description")
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(25)
        ])
      ]
    ),
    _vm._v(" "),
    _vm._m(26)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-dot" }, [
      _c("p", [
        _vm._v("กวาดและเก็บขยะโดยที่นำไปทิ้งยังที่ผู้ว่าจ้างจัดเตรียมไว้")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("ทำความสะอาดเก็บคราบฝุ่นพื้นที่ทั่วไปให้สะอาด")]),
      _vm._v(" "),
      _c("p", [_vm._v("ทำความสะอาดเก็บคราบสี/คราบปูน (ถ้ามี) ให้สะอาด")]),
      _vm._v(" "),
      _c("p", [_vm._v("ทำความสะอาดผนังบ้านหรือสำนักงานทั้งภายใน/ภายนอก")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("ขัดล้างพื้นเซรามิค, แกรนิตโต้, หินอ่อน, แกรนิต "),
        _c("br"),
        _vm._v(" ด้วยเครื่องขัดล้างพื้น พร้อมปัดเงาพื้น")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-dot" }, [
      _c("p", [_vm._v("ล้างทำความสะอาดห้องน้ำและสุขภันฑ์")]),
      _vm._v(" "),
      _c("p", [_vm._v("ทำความสะอาด ห้องครัวและอุปกรณ์")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("ทำความสะอาดโคมไฟ, ปลั๊กไฟ เฉพาะภายนอก (ไม่รวมโคมไฟระย้า)")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "เช็คทำความสะอาดเฟอร์นิเจอร์ (โต๊ะ เก้าอี้ ตู้ ชั้น ลิ้นชัก) ฯลฯ "
        ),
        _c("br"),
        _vm._v(" หรือเฟอร์นิเจอร์อินต่างๆ")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("ทำความสะอาด ดูดฝุ่นพรม (ถ้ามี), วอลเปเปอร์ (ถ้ามี)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-dot" }, [
      _c("p", [_vm._v("เช็คทำความสะอาดกระจกภายในและภายนอกพร้อมขอบเฟรม")]),
      _vm._v(" "),
      _c("p", [_vm._v("ทำความสะอาดลานซักล้าง, ทางเดินรอบบ้านและที่จอดรถ")]),
      _vm._v(" "),
      _c("p", [_vm._v("ทำความสะอาดมุ้งลวด, เหล็กดัด (ถ้ามี)")]),
      _vm._v(" "),
      _c("p", [_vm._v("ล้างทำความสะอาดบริเวณบันไดและเช็ดราวบันไดให้สะอาด")]),
      _vm._v(" "),
      _c("p", [_vm._v("การให้บริการทำความสะอาดอื่นๆ ตามที่ตกลง")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "text-center" }, [
      _vm._v("คำขอใบเสนอราคาบริการ "),
      _c("br"),
      _vm._v(" Big Cleaning")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-3" },
      [
        _c("p", { staticClass: "my-0" }, [_vm._v("ข้อมูลการติดต่อ")]),
        _vm._v(" "),
        _c("a", { attrs: { href: "#what-big-cleaning-service" } }, [
          _c(
            "button",
            { staticClass: "btn btn-light btn-sm", attrs: { type: "button" } },
            [_vm._v(" รายละเอียด Big Cleaning")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "name" } }, [
      _vm._v("ชื่อผู้ติดต่อ "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "email" } }, [
      _vm._v("อีเมล "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "tel" } }, [
      _vm._v("เบอร์โทร "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "purpose" } }, [
      _vm._v("วัตถุประสงค์การทำ Big Cleaning "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "province" } }, [
      _vm._v("จังหวัด "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "district" } }, [
      _vm._v("อำเภอ"),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "pb-2" }, [
      _c("i", { staticClass: "fal fa-images fa-lg" }),
      _vm._v("  แนบรูป\n                        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("p", { staticClass: "text-orange mb-0" }, [
        _vm._v("เงื่อนไขการให้บริการ")
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "พื้นที่ให้บริการเฉพาะในจังหวัด กรุงเทพฯ และปริมณฑล, เชียงใหม่ และชลบุรีเท่านั้น"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-orange mb-0" }, [_vm._v("หมายเหตุ")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                      การส่งคำขอนี้เป็นการส่งเพื่อประเมินราคาไม่ใช่การจองบริการเนื่องจากต้องมีการ\n                      เช็คคิวกับทีมงานหลังจากได้ราคาค่าบริการ และวันที่สะดวกเข้าให้บริการแล้วทางบีนีท\n                      จะส่งข้อมูลกลับไปให้คุณยืนยัน ถ้าคุณยอมรับราคา และวันที่เข้าให้บริการ\n                      คุณจำเป็นต้องชำระเงินค่ามัดจำก่อน 50% เพื่อยืนยันการจอง\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-6" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: "/static/img/bigCleaningNew/B_1.png",
          alt: "เหมาะกับห้องและบ้านที่ไม่ได้ทำความสะอาดมานาน"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#form-service" } }, [
      _c(
        "button",
        { staticClass: "btn btn-info py-1 px-1", attrs: { type: "button" } },
        [_vm._v("ประเมินราคา")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-none d-md-block" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: "/static/img/bigCleaningNew/B_2.png",
              alt: "รูปก่อนและหลังการทำความสะอาดตู้เย็น"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: "/static/img/bigCleaningNew/B_3.png",
              alt: "รูปก่อนและหลังการทำความสะอาดระเบียง"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#form-service" } }, [
      _c(
        "button",
        { staticClass: "btn btn-info py-1 px-1", attrs: { type: "button" } },
        [_vm._v("ประเมินราคา")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-none d-md-block" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: "/static/img/bigCleaningNew/B_5.png",
              alt: "รูปก่อนและหลังการทำความสะอาดห้องน้ำ"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: "/static/img/bigCleaningNew/B_4.png",
              alt: "รูปก่อนแหละหลังการทำความสะอาดระเบียง"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-6 order-0 order-md-1" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: "/static/img/bigCleaningNew/B_6.png",
          alt: "เหมาะกับห้องและบ้านก่อนเข้าหรือหลังย้ายออก"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-6" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: "/static/img/bigCleaningNew/B_7.png",
          alt: "เหมาะกับห้องและบ้านหลังการก่อสร้างหรือรีโนเวท"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#form-service" } }, [
      _c(
        "button",
        { staticClass: "btn btn-info py-1 px-1", attrs: { type: "button" } },
        [_vm._v("ประเมินราคา")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-none d-md-block" }, [
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: "/static/img/bigCleaningNew/B_8.png",
              alt: "ห้องหลังก่อสร้างหรือรีโนเวท"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: "/static/img/bigCleaningNew/B_9.png",
              alt: "ขัดพื้นด้วยอุปกรณ์มืออาชีพ"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row d-flex justify-content-center" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: "static/img/bigCleaningNew/R_3.png",
            alt: "ทำความสะอาดหลังปรับปรุงรีโนเวทบ้าน"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row d-flex justify-content-center" }, [
      _c("div", { staticClass: "col-sm-6 d-inline-flex" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: "static/img/bigCleaningNew/R_1.png",
            alt: "รูปก่อนแหละหลังทำความสะอาด1"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-6 d-inline-flex" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: "static/img/bigCleaningNew/R_2.png",
            alt: "รูปก่อนแหละหลังทำความสะอาด2"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-block d-flex justify-content-center" }, [
      _c("a", { attrs: { href: "#form-service" } }, [
        _c(
          "button",
          {
            staticClass: "btn btn-info py-1 px-1 mb-3",
            attrs: { type: "button" }
          },
          [_vm._v("ประเมินราคา")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-block d-flex justify-content-center" }, [
      _c("a", { attrs: { href: "#form-service" } }, [
        _c(
          "button",
          { staticClass: "btn btn-info py-1 px-1", attrs: { type: "button" } },
          [_vm._v("ประเมินราคา")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "rate-price" } }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "row", staticStyle: { "margin-bottom": "2.5em" } },
          [
            _c(
              "div",
              {
                staticClass: "col-12 col-md-6",
                staticStyle: { padding: "15px 15px 15px 15px" }
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: "static/img/bigCleaningNew/PRICE.png",
                    alt: "อัตราค่าบริการ"
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "text-secondary text-right" }, [
                  _vm._v(
                    "*เป็นราคาเริ่มต้น บริษัทจะประเมินละเอียดอีกครั้งจากหน้างานจริง"
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "align-items-center col-12 col-md-6 d-flex justify-content-center"
              },
              [
                _c("div", {}, [
                  _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column text-center" },
                      [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: "static/img/bigCleaningNew/QR_CODE_LINE.png",
                            alt: "ติดต่อเจ้าหน้าที่"
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v("ติดต่อเจ้าหน้าที่")
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "text-highlight mb-3",
                            attrs: { href: "tel:+6621131138" }
                          },
                          [_vm._v("02-113-1138")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-success",
                            attrs: {
                              href: "https://line.me/R/ti/p/%40hnk7011n",
                              target: "_blank"
                            }
                          },
                          [_vm._v("LINE ID:\n                    @BeNeat")]
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-block d-flex justify-content-center" }, [
        _c(
          "a",
          { staticClass: "text-center", attrs: { href: "#header-banner" } },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                staticStyle: { "border-radius": "25px" },
                attrs: { type: "button" }
              },
              [_c("i", { staticClass: "fa fa-chevron-up fa-2x" })]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticStyle: { color: "#32a2b8" } }, [
              _vm._v("BACK TO TOP")
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45089d8c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45089d8c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/BigCleaningNew.vue
// module id = 1485
// module chunks = 0